<script setup>
  import { defineProps } from 'vue'

  import ResultsLineSingle from './ResultsLineSingle.vue';

  const props = defineProps({
    clockwiseData: Array,
    antiClockwiseData: Array,
    flipped: {
      type: Boolean,
      default: false
    }
  });



</script>
<template>

  <div class="result">

    <template v-if="flipped">
      <ResultsLineSingle
        :acw="true"
        :data="props.antiClockwiseData"
        :flipped="flipped"
      />
      <hr/>
    </template>

    <ResultsLineSingle
      :acw="false"
      :data="props.clockwiseData"
      :flipped="flipped"
    />

    <template v-if="!flipped">
      <hr/>
      <ResultsLineSingle
        :acw="true"
        :data="props.antiClockwiseData"
        :flipped="flipped"
      />
    </template>

  </div>
</template>
